import styled from 'styled-components';
import { Section } from '../components/Section';
import { IllustratedCTA } from '../components/IllustratedCTA';
import { Power } from '../components/Power';
import { ContactForm } from '../components/ContactForm';
import { Verbatim } from '../components/Verbatim';
import { Accost } from '../components/Accost';
import { Article } from '../components/Article';
import { Info } from '../components/Info';
import { About } from '../components/About';
import { Consultancy } from '../components/Consultancy';
import { Stability } from '../components/Stability';
import { Dynamics } from '../components/Dynamics';
// import { Appointments } from '../components/Appointments';
import { Payments } from '../components/Payments';
import { NewsletterSignUp } from '../components/NewsletterSignUp';
import { IllustratedPayment } from '../components/IllustratedPayment';
import { db, collection, doc } from '../firebase';

export const dbHero = doc(db, 'home/hero');
export const dbHowAreYou = doc(db, 'home/howareyou');
export const dbFlyers = doc(db, 'home/flyers');
export const dbAbout = doc(db, 'home/about');
export const dbStability = doc(db, 'home/stability');
export const dbDynamics = doc(db, 'home/dynamics');
export const dbConsultancy = doc(db, 'home/consultancy');

const Page = styled.div`
	display: grid;
	grid-gap: 80px;
`;

const Columns = styled.div`
	display: grid;
	grid-gap: 80px;
	grid-template-columns: 1fr 1fr;
	padding-top: 80px;
`;

export const HomePage = () => {
	const data = {
		verbatims: {
			heading: "Moja praca przynosi pożądane efekty",
			items: ["vigXOBMbQtyw7FSlVxav", "gNPhm7LcSzE63P66KK42", "EJOCEBA1dzHdTK0O9kpQ"]
		},
		info2: {
			heading: "Każdy kolejny dzień zwłoki może oznaczać większą frustrację"
		}
	};

	return <Page>
		{/* <Appointments /> */}
		<IllustratedCTA ctaId="mGalMlBDNxZT6OR6VEWt" imageId="YhEwr0VUq4cr0Ylv2Lre" locale="pl-PL" />
		<IllustratedPayment imageId="WGi3WMFzeyFDygxkOGyP" paymentId="8iTlN3bWBVEDXjgbM52r" locale="pl-PL" />
		<Accost res={{ base: dbHowAreYou, localized: doc(dbHowAreYou, 'localized/pl-PL') }} />
		<Info componentId="JMZmlVObrbOfKqedVB8a" locale="pl-PL" />
		<Power res={{ base: dbFlyers, localized: doc(dbFlyers, 'localized/pl-PL'), items: collection(dbFlyers, 'items') }} />
		<Payments order={["QWyFfoDm2HGcWh07ihDE", "bFKCTnXW7eNJ66j6RFeC", "opdF5LdQjH4bdD2aEleK"]} locale="pl-PL" />
		<Columns id="energia">
			<Dynamics res={{ base: dbDynamics, localized: doc(dbDynamics, 'localized/pl-PL') }} />
			<Stability res={{ base: dbStability, localized: doc(dbStability, 'localized/pl-PL') }} />
		</Columns>
		<Section heading={data.verbatims.heading} layout="columns">
			{data.verbatims.items.map((id: string) => <Verbatim key={id} componentId={id} locale="pl-PL" />)}
		</Section>
		<Columns>
			<About res={{ base: dbAbout, localized: doc(dbAbout, 'localized/pl-PL') }} />
			<Consultancy res={{ base: dbConsultancy, localized: doc(dbConsultancy, 'localized/pl-PL') }} />
		</Columns>
		<NewsletterSignUp componentId="PsEmJssAfJBiFE7Zj26F" imageId="gB6RspDBjuRcKoDPz8mn" locale="pl-PL" />
		<Section>
			<Info componentId="EpkrwOw4gbCl1aAr2GE1" locale="pl-PL" />
		</Section>
		<ContactForm />
	</Page>
}